var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgReload = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 28 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.1 25.7c-.5.4-1.3.2-1.6-.3-.4-.5-.2-1.3.3-1.6 2.8-1.9 4.7-5.5 4.7-9C24.5 9 19.8 4.3 14 4.3S3.5 9 3.5 14.8c0 5.6 4.3 10.1 9.8 10.5l-1.7-2.9c-.3-.6-.1-1.3.4-1.6.6-.3 1.3-.1 1.6.4l2.5 4.4c.2.3.2.6.1.9-.1.3-.3.6-.6.7l-4.7 2.6c0 .2-.2.2-.4.2-.4 0-.8-.2-1-.6-.3-.6-.1-1.3.4-1.6l1-.5c-5.6-1.4-9.7-6.4-9.7-12.4C1.2 7.8 6.9 2 14 2s12.8 5.8 12.8 12.8c0 4.3-2.2 8.6-5.7 10.9z",
  fill: "#fff"
})));

export default SvgReload;